import accounting from 'accounting';
import i18next from 'i18next';

export const currencySymbols = {
  ALL: 'ALL',
  AFN: 'AFN',
  ARS: 'ARS',
  AWG: 'AWG',
  AUD: 'A$',
  AZN: 'AZN',
  BSD: 'BSD',
  BBD: 'BBD',
  BYR: 'BYR',
  BZD: 'BZD',
  BMD: 'BMD',
  BOB: 'BOB',
  BAM: 'BAM',
  BWP: 'BWP',
  BGN: 'BGN',
  BRL: 'R$',
  BND: 'BND',
  KHR: 'KHR',
  CAD: 'CA$',
  KYD: 'KYD',
  CLP: 'CLP',
  CNY: 'CN¥',
  COP: 'COP',
  CRC: 'CRC',
  HRK: 'HRK',
  CUP: 'CUP',
  CZK: 'CZK',
  DKK: 'DKK',
  DOP: 'DOP',
  XCD: 'EC$',
  EGP: 'EGP',
  SVC: 'SVC',
  EEK: 'EEK',
  EUR: '€',
  FKP: 'FKP',
  FJD: 'FJD',
  GHC: 'GHC',
  GIP: 'GIP',
  GTQ: 'GTQ',
  GGP: 'GGP',
  GYD: 'GYD',
  HNL: 'HNL',
  HKD: 'HK$',
  HUF: 'HUF',
  ISK: 'ISK',
  INR: '₹',
  IDR: 'IDR',
  IRR: 'IRR',
  IMP: 'IMP',
  ILS: '₪',
  JMD: 'JMD',
  JPY: 'JP¥',
  JEP: 'JEP',
  KES: 'KES',
  KZT: 'KZT',
  KPW: 'KPW',
  KRW: '₩',
  KGS: 'KGS',
  LAK: 'LAK',
  LVL: 'LVL',
  LBP: 'LBP',
  LRD: 'LRD',
  LTL: 'LTL',
  MKD: 'MKD',
  MYR: 'MYR',
  MUR: 'MUR',
  MXN: 'MX$',
  MNT: 'MNT',
  MZN: 'MZN',
  NAD: 'NAD',
  NPR: 'NPR',
  ANG: 'ANG',
  NZD: 'NZ$',
  NIO: 'NIO',
  NGN: 'NGN',
  NOK: 'NOK',
  OMR: 'OMR',
  PKR: 'PKR',
  PAB: 'PAB',
  PYG: 'PYG',
  PEN: 'PEN',
  PHP: 'PHP',
  PLN: 'PLN',
  QAR: 'QAR',
  RON: 'RON',
  RUB: 'RUB',
  RMB: 'RMB',
  SHP: 'SHP',
  SAR: 'SAR',
  RSD: 'RSD',
  SCR: 'SCR',
  SGD: 'SGD',
  SBD: 'SBD',
  SOS: 'SOS',
  ZAR: 'ZAR',
  LKR: 'LKR',
  SEK: 'SEK',
  CHF: 'CHF',
  SRD: 'SRD',
  SYP: 'SYP',
  TZS: 'TZS',
  TWD: 'NT$',
  THB: '฿',
  TTD: 'TTD',
  TRY: 'TRY',
  TRL: 'TRL',
  TVD: 'TVD',
  UGX: 'UGX',
  UAH: 'UAH',
  GBP: '£',
  USD: '$',
  UYU: 'UYU',
  UZS: 'UZS',
  VEF: 'VEF',
  VND: '₫',
  YER: 'YER',
  ZWD: 'ZWD',
  GEL: 'GEL',
  AED: 'AED',
};

export const getSymbolFromCurrency = currencyCode => {
  if (typeof currencyCode !== 'string') {
    return null;
  }

  return currencySymbols[currencyCode.toUpperCase()] || null;
};

const formatPrice = (price, currencyCode, precision = 2) => {
  if (price === null) {
    return null;
  }

  return accounting.formatMoney(price, {
    symbol: getSymbolFromCurrency(currencyCode),
    thousand: i18next.t('landlord.currency.thousand_symbol'),
    format: i18next.t('landlord.currency.symbol_value_order'),
    precision,
  });
};

export default formatPrice;
